import { getAppStore } from "../app/app.bridge";
import { resolveMethod4Key } from "@/utils/optimizationData";
/** Pinia app store — selectedBeta (micro-7-3 birincil kaynak) */
export function getSelectedBeta(override) {
    if (override != null)
        return override;
    const beta = getAppStore().selectedBeta;
    return beta != null ? beta : 0;
}
/** Pinia app store — currentMethod + selectedBeta → methodKey */
export function resolveMethodKey() {
    const app = getAppStore();
    const currentMethod = app.currentMethod;
    const selectedBeta = getSelectedBeta();
    return currentMethod === 4 ? resolveMethod4Key(selectedBeta) : `method${currentMethod}`;
}
/** Pinia köprüsü — optimizationData */
export function getOptimizationData() {
    return getAppStore().optimizationData;
}
/** Pinia köprüsü — analysisData */
export function getAnalysisData() {
    return getAppStore().analysisData;
}
/** Pinia köprüsü — has analysisData */
export function hasAnalysisData() {
    return getAppStore().hasAnalysisData;
}
